export enum FireworksType {
  checker = "checker",
  stars = "stars",
  stripes = "stripes",
  swiggle = "swiggle",
  full = "full"
}
export enum FireworksColor {
  red = "red",
  purple = "purple",
  green = "green",
  blue = "blue"
}

export enum Sounds {
  click1 = "click1",
  click2 = "click2",
  click3 = "click3",
  clickOnBadFirework = "clickOnBadFirework",
  explode1 = "explode1",
  explode2 = "explode2",
  success = "success",
  success2 = "success",
  background = "background"
}

export enum HTPEllipseColor {
  sameType = 0xFF0000,
  sameColor = 0x00FF00
}

export enum ButtonStatus {
  semiOpacity = "Semi-Opacity",
  show = "visible_true",
  hide = "visible_false"
}

export enum PlayButtonOpts {
  play = "PLAY_BUTTON",
  autoPlay = "AUTO_PLAY_BUTTON"
}

export enum BetAmountStatus {
  max ="MAX",
  min = "MIN",
  nonExtreme = "NON_EXTREME_VALUE"
}